import React, { useState, useEffect } from "react";
import LigIcon from "../../assets/components/LigIcon";
import LigMenuButtom from "../../assets/components/IigButtons";
import LigRules from "./LigRules";
import LigIntro from "./LigIntroduction";
import LigHelp from "./LigHelp";
import { useNavigate } from "react-router";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";

const Lig = () => {
  const [showRules, setShowRules] = useState(false);
  const [showIntro, setShowIntro] = useState(false);
  const [showBackup, setShowBackup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add("profileBg");
    return () => {
      document.body.classList.remove("profileBg");
    };
  }, []);

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <LigIcon />
        <div className="row p-0 m-0">
          <div className="col-8 p-0">
            <LigMenuButtom
              title={"شروع چالش"}
              size={"large"}
              handleClick={() => navigate("/lig/map")}
            />
          </div>
          <div className="col-4 p-0">
            <LigMenuButtom
              title={"معرفی"}
              handleClick={() => setShowIntro(true)}
            />
            <LigMenuButtom
              title={"پیشتازان"}
              handleClick={() => navigate("/lig/leaderBoard")}
            />
          </div>
          <div className="col-4 p-0">
            <LigMenuButtom
              title={"پشتیبانی"}
              handleClick={() => setShowBackup(true)}
            />
          </div>
          <div className="col-4 p-0">
            <LigMenuButtom
              title={"قوانین"}
              handleClick={() => setShowRules(true)}
            />
          </div>
          <div className="col-4 p-0">
            <LigMenuButtom
              title={"امتیاز بیشتر"}
              handleClick={() => navigate(`/lig/challenges/gift`)}
            />
          </div>
        </div>
      </div>
      <LigRules show={showRules} closeHander={() => setShowRules(false)} />
      <LigIntro show={showIntro} closeHander={() => setShowIntro(false)} />
      <LigHelp show={showBackup} closeHander={() => setShowBackup(false)} />
    </AnimatedPageContainer>
  );
};

export default Lig;
